var map = {
	"./screening-camp1.jpeg": 81300,
	"./screening-camp2.jpeg": 43509,
	"./screening-camp3.jpeg": 40174,
	"./screening-camp4.jpeg": 54583,
	"./screening-camp5.jpeg": 92704,
	"./screening-camp6.jpeg": 83585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59512;